import React from 'react'
import { ContinueWithApple } from './ContinueWithApple'
import { ContinueWithEmail } from './ContinueWithEmail'
import { ContinueWithGoogle } from './ContinueWithGoogle'
import { ContinueWithPhoneNumber } from './ContinueWithPhoneNumber'
import config from '@/config/env'
// import { ContinueWithTelegram } from './ContinueWithTelegram'

import { BaseView } from '@/components'
import { useAppAnalytics } from '@/services/analytics'
import { useEffect } from 'react'

export const IdentificationMethods: React.FC = () => {
  const ENABLE_PHONE_SIGN_IN = config.ENABLE_PHONE_SIGN_IN
  const ENABLE_APPLE_SIGN_IN = config.ENABLE_APPLE_SIGN_IN
  const ENABLE_GOOGLE_SIGN_IN = config.ENABLE_GOOGLE_SIGN_IN
  const showApple = String(ENABLE_APPLE_SIGN_IN) === 'true'
  const showGoogle = String(ENABLE_GOOGLE_SIGN_IN) === 'true'



  const { trackEvent, events } = useAppAnalytics()

  useEffect(() => {
    trackEvent(events.SIGNUP_STARTED, {
      entry_point: 'website',
    })
  }, [trackEvent, events.SIGNUP_STARTED])

  return (
    <BaseView gap={12}>
      {/* Telegram авторизация (только в Telegram WebApp) */}
      {/* <ContinueWithTelegram /> */}

      {/* Традиционные методы */}
      <ContinueWithEmail />

      {<ContinueWithPhoneNumber />}

      {/* OAuth методы */}
      {showApple && <ContinueWithApple />}
      {showGoogle && <ContinueWithGoogle />}
    </BaseView>
  )
}
